import React from 'react';

export function PartnerInstitutional(props: { img: string; link: string; name: string }) {
    return (
        <a href={props.link} target={'_blank'} rel={'noreferrer'}>
            <div
                className={
                    'box-shadow flex h-20 w-52 cursor-pointer items-center justify-center bg-white p-16 sm:h-36 sm:w-72 '
                }>
                <img
                    src={props.img}
                    alt={props.name}
                    className={'min-w-[110px] sm:min-w-[160px]'}
                />
            </div>
        </a>
    );
}

export function Partner(props: { img: string; link: string; name: string }) {
    return (
        <a href={props.link} target={'_blank'} rel={'noreferrer'}>
            <div
                className={
                    'box-shadow flex h-52 w-52 cursor-pointer items-center justify-center bg-white p-8 hover:scale-[110%]'
                }>
                <img src={props.img} alt={props.name} className={'max-h-[160px]'} />
            </div>
        </a>
    );
}
